var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vuestic-tag",class:_vm.tagClass},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.removable)?_c('span',{staticClass:"vuestic-tag-button",on:{"click":_vm.remove}},[_c('i',{staticClass:"ion-md-close ion"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }